export default "__VITE_ASSET__BCukyVP8__"